import { apiHelper, sharedHelper, sessionHelper } from '@/utils'
import { API } from '@/constants'

export const companyLocationService = {
    getAllLocations,
    getLocation,
    updateLocation,
    updateLocationStatus,
    createLocation,
    updateLocationGeomerty,
    updateLocationDisablePackageService,
    getAllLocationsPublic,
    getLocationPublic
};

const MODULE = {
    LOCATION: 'company-locations',
    PUBLIC: 'public-company-locations',
}

// const API_URL = API.BASE_URL.replace('@serviceName', 'user') + '/v1'
const API_URL = API.BASE_URL + '/v1'


export function getAllLocations(filter) {
    const requestOptions = {
        params: {
            page: filter.pageNumber,
            size: filter.pageSize,
            is_active: filter.isActive,
        }
    }

    let array = filter.searchArray
    array.forEach((word, index) => {
        if (word != null || word != '') {
            var searchParam = `search_words[${index}]`
            requestOptions.params[searchParam] = word
        }
    })

    if (sessionHelper.getUserType == "STAFF") {
        requestOptions.params['company'] = sessionHelper.getStaffCompanyUUID()
    }


    return apiHelper(API_URL).get(`/${MODULE.LOCATION}`, requestOptions)
}

export function getLocation(id) {
    return apiHelper(API_URL).get(`/${MODULE.LOCATION}/${id}`)
}

export function updateLocation(data) {

    const formData = new FormData();
    sharedHelper.appendIfNotNull(formData, 'name', data.name);
    sharedHelper.appendIfNotNull(formData, 'phone_code', data.phoneCode);
    sharedHelper.appendIfNotNull(formData, 'phone_iso', data.phoneISO);
    sharedHelper.appendIfNotNull(formData, 'phone', data.phone);
    sharedHelper.appendIfNotNull(formData, 'email', data.email);
    sharedHelper.appendIfNotNull(formData, 'company_uuid', data.companyID);
    sharedHelper.appendIfNotNull(formData, 'location_uuid', data.locationID);
    sharedHelper.appendIfNotNull(formData, 'address_1', data.address1);
    sharedHelper.appendIfNotNull(formData, 'postcode', data.postcode);
    sharedHelper.appendIfNotNull(formData, 'state', data.state);
    sharedHelper.appendIfNotNull(formData, 'city', data.city);
    sharedHelper.appendIfNotNull(formData, 'map_url', data.mapURL);
    sharedHelper.appendIfNotNull(formData, 'latitude', data.latitude);
    sharedHelper.appendIfNotNull(formData, 'longitude', data.longtitude);

    if (data.companyTypeIDs != null) {
        data.companyTypeIDs.forEach(typeID => formData.append('company_type_uuids[]', typeID));
    }

    if (data.logo instanceof File) {
        formData.append('logo', data.logo);
    }

    if (data.isHQ != "") {
        formData.append('is_hq', data.isHQ == true ? 1 : 0);
    }
    else {
        formData.append('is_hq', 0);
    }

    if (data.isAllowAppointment != "") {
        formData.append('is_allow_appointment', data.isAllowAppointment == true ? 1 : 0);
    }
    else {
        formData.append('is_allow_appointment', 0);
    }

    formData.append('_method', "put");


    return apiHelper(API_URL).post(`/${MODULE.LOCATION}/${data.id}`, formData)
}

export function createLocation(data) {

    const formData = new FormData();
    sharedHelper.appendIfNotNull(formData, 'name', data.name);
    sharedHelper.appendIfNotNull(formData, 'phone_code', data.phoneCode);
    sharedHelper.appendIfNotNull(formData, 'phone_iso', data.phoneISO);
    sharedHelper.appendIfNotNull(formData, 'phone', data.phone);
    sharedHelper.appendIfNotNull(formData, 'email', data.email);
    sharedHelper.appendIfNotNull(formData, 'company_uuid', data.companyID);
    sharedHelper.appendIfNotNull(formData, 'location_uuid', data.locationID);
    sharedHelper.appendIfNotNull(formData, 'address_1', data.address1);
    sharedHelper.appendIfNotNull(formData, 'postcode', data.postcode);
    sharedHelper.appendIfNotNull(formData, 'state', data.state);
    sharedHelper.appendIfNotNull(formData, 'city', data.city);
    sharedHelper.appendIfNotNull(formData, 'map_url', data.mapURL);
    sharedHelper.appendIfNotNull(formData, 'latitude', data.latitude);
    sharedHelper.appendIfNotNull(formData, 'longitude', data.longtitude);

    if (data.companyTypeIDs != null) {
        data.companyTypeIDs.forEach(typeID => formData.append('company_type_uuids[]', typeID));
    }

    if (data.logo instanceof File) {
        formData.append('logo', data.logo);
    }

    if (data.isHQ != "") {
        formData.append('is_hq', data.isHQ == true ? 1 : 0);
    }
    else {
        formData.append('is_hq', 0);
    }

    if (data.isAllowAppointment != "") {
        formData.append('is_allow_appointment', data.isAllowAppointment == true ? 1 : 0);
    }
    else {
        formData.append('is_allow_appointment', 0);
    }

    return apiHelper(API_URL).post(`/${MODULE.LOCATION}`, formData)
}

export function updateLocationStatus(data) {
    const requestOptions = {
        is_active: data.isActive
    }

    return apiHelper(API_URL).patch(`/${MODULE.LOCATION}/${data.id}`, requestOptions)
}

export function updateLocationGeomerty(data) {
    const requestOptions = {
        latitude: data.latitude,
        longitude: data.longitude,
        company_location_uuid: data.companyLocationID
    }
    return apiHelper(API_URL).put(`/${MODULE.LOCATION}/${data.id}`, requestOptions)
}

export function updateLocationDisablePackageService(data) {
    const requestOptions = {
        services: data.services,
        packages: data.packages,
        uuid: data.id
    }

    return apiHelper(API_URL).put(`/${MODULE.LOCATION}/package-service/own`, requestOptions)
}

export function getAllLocationsPublic(filter) {
    const requestOptions = {
        params: {
            page: filter.pageNumber,
            size: filter.pageSize,
            is_active: filter.isActive,
        }
    }

    let array = filter.searchArray
    array.forEach((word, index) => {
        if (word != null || word != '') {
            var searchParam = `search_words[${index}]`
            requestOptions.params[searchParam] = word
        }
    })

    return apiHelper(API_URL).get(`/${MODULE.PUBLIC}`, requestOptions)
}

export function getLocationPublic(id) {
    return apiHelper(API_URL).get(`/${MODULE.PUBLIC}/${id}`)
}